// Workout session engine: turns a workout configuration into a flat, timed step timeline.
// Pure functions — reusable by any program (challenge, hypertrophy, HYROX, ...).

export const fmt = (s) => {
  const t = Math.max(0, Math.round(s));
  return `${String(Math.floor(t / 60)).padStart(2, "0")}:${String(t % 60).padStart(2, "0")}`;
};

const BANNER_SECONDS = 2.5;

export function buildTimeline(cfg) {
  const steps = [];
  const work = (item, extra = {}) => ({
    kind: "work",
    name: item.name,
    exercise_type: item.exercise_type,
    alternating: !!item.alternating,
    side: item.side || "none",
    seconds: item.work_seconds,
    work_seconds: item.work_seconds,
    rest_seconds: item.rest_seconds,
    video: item.video,
    ...extra,
  });

  if (cfg.warmup?.length) {
    steps.push({ kind: "banner", label: "WARM-UP", seconds: BANNER_SECONDS });
    cfg.warmup.forEach((it, i) => steps.push(work(it, { section: "Warm-up", secIndex: i + 1, secTotal: cfg.warmup.length })));
  }
  steps.push({ kind: "banner", label: "LET'S GO", seconds: BANNER_SECONDS });

  const R = cfg.main?.rounds || 1;
  const exs = cfg.main?.exercises || [];
  for (let r = 1; r <= R; r++) {
    exs.forEach((it, i) => {
      steps.push(work(it, { section: "Workout", round: r, rounds: R, exIndex: i + 1, exTotal: exs.length }));
      const lastOfRound = i === exs.length - 1;
      if (lastOfRound && r < R && (cfg.main?.rest_between_rounds || 0) > 0) {
        // round break REPLACES the last exercise's rest — one clean 60s break, no hidden extra 30s
        steps.push({ kind: "rest", label: "ROUND BREAK", seconds: cfg.main.rest_between_rounds, round: r, rounds: R, nextEx: `1 / ${exs.length}` });
      } else if (lastOfRound && r === R) {
        // FINAL RECOVERY: last exercise's rest + server-computed dynamic top-up -> session total is exactly the target (25:00)
        const secs = (it.rest_seconds || 0) + (cfg.recovery_seconds || 0);
        if (secs > 0) steps.push({ kind: "rest", label: "RECOVERY", seconds: secs, round: r, rounds: R, nextEx: "Cool down" });
      } else if (it.rest_seconds > 0) {
        const nextEx = i + 1 < exs.length ? `${i + 2} / ${exs.length}` : (r < R ? `1 / ${exs.length}` : null);
        steps.push({ kind: "rest", label: "REST", seconds: it.rest_seconds, round: r, rounds: R, nextEx });
      }
    });
  }

  if (cfg.cooldown?.length) {
    steps.push({ kind: "banner", label: "COOL DOWN", seconds: BANNER_SECONDS });
    cfg.cooldown.forEach((it, i) => steps.push(work(it, { section: "Cool down", secIndex: i + 1, secTotal: cfg.cooldown.length })));
  }
  steps.push({ kind: "done" });

  // annotate "up next"
  for (let i = 0; i < steps.length; i++) {
    const nxt = steps.slice(i + 1).find((s) => s.kind === "work" || s.kind === "rest");
    steps[i].upNext = nxt ? (nxt.kind === "rest" ? nxt.label || "Rest" : nxt.name) : null;
  }
  return steps;
}
